<script setup lang="ts">
import { useEmbodiment } from './composables/use-embodiment';
import { ref, watch } from 'vue';
import { useScroll2bottom } from '@telecom/shared/composables/use-scroll2bottom';
import { useI18n } from 'vue-i18n';

const embodimentContent = ref<HTMLElement | null>(null);

const { t } = useI18n();
const { scroll2bottomWithLimit } = useScroll2bottom(embodimentContent);
const { embodiment, isGeneratingEmbodiment, updateEmbodimentContent } = useEmbodiment();

watch(() => embodiment.value.content, () => {
    scroll2bottomWithLimit();
});
</script>

<template>
    <div class="embodiment-content flex flex-col overflow-hidden">
        <!-- 实施例规则列表区域 -->
        <div class="embodiment-content__rules flex-1 overflow-auto">
            <!-- 遍历显示每条实施例规则 -->
            <div
                v-for="(item, index) in embodiment.rules"
                :key="item.id"
                class="embodiment-content__rule-item rounded px-2 py-1 bg-gray-10 leading-6 flex items-center mb-1 last-of-type:mb-0"
            >
                <!-- 规则序号 -->
                <span class="text-gray-90 mr-2 flex-shrink-0">
                    {{ t('aiSpecification.embodiment.rule', { num: index + 1 }) }}
                </span>
                <!-- "替换"文本 -->
                <span class="mr-1 flex-shrink-0">
                    {{ t('aiSpecification.embodiment.replace') }}
                </span>
                <!-- 权利要求特征 -->
                <span class="rounded px-2 bg-green-75">
                    <!-- 权利要求编号 -->
                    <span class="text-gray-450">
                        {{ t('aiSpecification.claimNum', { num: item.claimFeature.num }) }}
                    </span>
                    <!-- 权利要求特征内容 -->
                    <span class="ml-1">
                        {{ item.claimFeature.feature }}
                    </span>
                </span>
                <!-- "为"文本 -->
                <span class="mx-1 flex-shrink-0">
                    {{ t('aiSpecification.embodiment.with') }}
                </span>
                <!-- 替换的关键词 -->
                <span class="rounded px-2 bg-green-75">
                    {{ item.keyword.value }}
                </span>
            </div>
        </div>
        <!-- 实施例内容编辑区域 -->
        <textarea
            ref="embodimentContent"
            :value="embodiment.content"
            :disabled="isGeneratingEmbodiment"
            :placeholder="t('aiSpecification.embodiment.placeholder')"
            class="th-textarea th-textarea-fixed w-full h-[124px] mt-4 flex-shrink-0"
            @input="updateEmbodimentContent(($event.target as HTMLTextAreaElement).value)"
        />
    </div>
</template>
